// extracted by mini-css-extract-plugin
module.exports = {"audioComponent":"AudioPropertyForm_audioComponent__2VjxQ","addSrcButton":"AudioPropertyForm_addSrcButton__3Mmgv","input":"AudioPropertyForm_input__3Ur4C"};